import { useMutation, useQueryClient } from 'react-query';
import {
  generateFanLetter,
  type GenerateFanLetterResponse
} from '../../services/bettieFanLettersService';

export function useGenerateFanLetter({ letterId }: { letterId: string }) {
  const queryClient = useQueryClient();
  return useMutation<GenerateFanLetterResponse, Error, { id: string }>(
    () => generateFanLetter({ id: letterId }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['fanLetter', letterId]);
      }
    }
  );
}
